import {
	ADMINUPDATEMODULEALLOCATION_SUCCESS,
	ADMINUPDATEMODULEALLOCATION_FAILED,
	RESET_ADMINUPDATEMODULEALLOCATION,
	LOADING_ADMINUPDATEMODULEALLOCATION,
	NETWORK_ERROR_ADMINUPDATEMODULEALLOCATION
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminUpdateModuleAllocation = () => {
	return { type: RESET_ADMINUPDATEMODULEALLOCATION };
};

const adminUpdateModuleAllocation =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_ADMINUPDATEMODULEALLOCATION });
		await adminServices
			.post("updateModuleAllocationList", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(adminUpdateModuleAllocationsuccess(res.data));
						break;
					default:
						dispatch(adminUpdateModuleAllocationFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_ADMINUPDATEMODULEALLOCATION,
					payload: err
				});
			});
	};
function adminUpdateModuleAllocationsuccess(data) {
	return {
		type: ADMINUPDATEMODULEALLOCATION_SUCCESS,
		payload: data
	};
}
function adminUpdateModuleAllocationFailed(data) {
	return {
		type: ADMINUPDATEMODULEALLOCATION_FAILED,
		payload: data
	};
}

export { resetAdminUpdateModuleAllocation, adminUpdateModuleAllocation };
